const getDropdownTitle = (label: string) => {
  return { value: '', label, isTitle: true };
};

const getDateDropdownItem = (quarter?: number, year?: number) => {
  if (!quarter) {
    return { value: 'finished', label: 'Сдан' };
  }

  return { value: `${quarter}.${year}`, label: `до ${quarter} квартала` };
};

const getQuarter = (date: Date) => {
  const month = Math.floor(date.getMonth() / 3) + 2;

  return month > 4 ? month - 4 : month;
};

export const generateDatesForDropdown = (): IDesktopDropdown[] => {
  const result = [
    { value: '', label: 'Любой срок сдачи' },
    { value: 'finished', label: 'Сдан' },
  ];

  const addQuarters = (quarter: number, year: number) => {
    let counter = quarter;
    while (counter <= 4) {
      result.push(getDateDropdownItem(counter, year));
      counter++;
    }
  };

  const date = new Date();
  let currentYear = date.getFullYear();
  let currentQuarter = getQuarter(date);
  const lastYear = currentYear + 5;

  while (currentYear <= lastYear + 1) {
    result.push(getDropdownTitle(`${currentYear} год`));
    addQuarters(currentQuarter, currentYear);
    currentQuarter = 1;
    currentYear++;
  }

  return result;
};

export const formatQuarterDate = (value?: string | null) => {
  if (value === 'finished') {
    return 'Сдан';
  }
  if (!value || value.indexOf('.') === -1) {
    return;
  }

  const dates = value.split('.');

  return `до ${dates[0]} кв. ${dates[1]}`;
};

export interface IDesktopDropdown {
  label: string;
  value: string;
  isTitle?: boolean;
}
